module.exports = __webpack_public_path__ + "media/newstyle/images/relatorio2-a2cfb058e80c79f2669483f50bea62a3.png";